import React from "react";
import "./Todo.css";

const Todo = () => {
  const [todos, setTodos] = React.useState([]);
  const [inputValue, setInputValue] = React.useState("");

  //For editing
  const [editMode, setEditMode] = React.useState(false);
  const [editId, setEditId] = React.useState(null);
  const [editValue, setEditValue] = React.useState("");

  const addTodo = () => {
    if (inputValue.trim() !== "") {
      // Object creation
      const newTodo = {
        id: new Date().getTime(),
        text: inputValue,
      };
      // spread to get the previous todos and add the new todo
      setTodos([...todos, newTodo]);
      setInputValue("");
    }
  };

  //Turn on edit mode and set required values
  const editTodo = (id, text) => {
    setEditMode(true);
    setEditId(id);
    setEditValue(text);
  };

  //Update the todo with required values
  const updateTodo = () => {
    const updatedTodos = todos.map((todo) => {
      // After mapping all the todos, if the todo id is equal to the editId, then update the text
      if (todo.id === editId) {
        return { ...todo, text: editValue };
      }
      return todo;
    });
    // Update the todos
    setTodos(updatedTodos);

    // Reset the values
    setEditMode(false);
    setEditId(null);
    setEditValue("");
  };

  const deleteTodo = (id) => {
    const updatedTodos = todos.filter((todo) => todo.id !== id);
    setTodos(updatedTodos);
  };

  return (
    <div className="todo-container">
      <h2>ToDo List</h2>
      <input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
      />

      {/* If editMode is true, then show the input field and update button */}
      {editMode && (
        <div>
          <input
            type="text"
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
          />

          {/* Function to update the todo */}
          <button onClick={updateTodo}>Update</button>
        </div>
      )}

      {!editMode && <button onClick={addTodo}>Add</button>}

      <ul>
        {todos.map((todo) => {
          return (
            <li key={todo.id}>
              {todo.text}
              <div>
                <button
                  onClick={() => {
                    // This function will turn on edit mode
                    editTodo(todo.id, todo.text);
                  }}
                >
                  Edit
                </button>
                <button
                  onClick={() => {
                    deleteTodo(todo.id);
                  }}
                >
                  Delete
                </button>
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Todo;
